import React from "react";
import Wrapper from "../Common/Wrapper";
import Loading from "../Common/Loading";
import Heading from "../Common/Heading";
import {StandardSorter} from "../../Utilities/Sorters";
import {
  ReloadOutlined} from "@ant-design/icons";
import {Table, Button, Input, Empty, message, Menu, Dropdown, Modal, Select, Form} from "antd";
import "moment/locale/el";
import {withRouter} from 'react-router-dom';
import ApiService from "../../services/ApiService";

const {Search} = Input;

const columns = [
  {
    title: "User Id",
    dataIndex: "userId",
    sorter: (a, b) => StandardSorter(a.userId, b.userId),
  },
  {
    title: "Email",
    dataIndex: "emailAddress",
    sorter: (a, b) => StandardSorter(a.emailAddress, b.emailAddress),
  },
  {
    title: "Company Code",
    dataIndex: "fCompanycode",
    sorter: (a, b) => StandardSorter(a.fCompanycode, b.fCompanycode),
  },
  {
    title: "Tax Registration Number",
    dataIndex: "taxRegistrationNumber",
    sorter: (a, b) => StandardSorter(a.taxRegistrationNumber, b.taxRegistrationNumber),
  },
  {
    title: "User Type",
    dataIndex: "userType",
    sorter: (a, b) => StandardSorter(a.userType, b.userType),
  },
  {
    title: "Inactive",
    dataIndex: "inactive",
    sorter: (a, b) => StandardSorter(a.inactive, b.inactive),
  },
];

class App extends React.Component {
  state = {
    searchText: "",
    loading: false,
    users: [],
    allUsers: [],
    isInsertFormModalOpen: false,
    editingUser: null,
    isAssignClientModalOpen: false,
    isAssignBranchModalOpen: false,
    selectedUser: null,
    clients: [],
    branches: [],
  };

  componentDidMount() {
    this.fetchUsers();
  }

  onSearchTextChange = (evt) => {
    const searchText = evt.target.value;
    this.setState({searchText});

    const {allUsers} = this.state;
    if (!searchText) {
      this.setState({users: allUsers});
      return;
    }

    const lowercasedSearchText = searchText.toLowerCase();

    const filteredUsers = allUsers.filter(user =>
      (user.taxRegistrationNumber && user.taxRegistrationNumber.toLowerCase().includes(lowercasedSearchText)) ||
      (user.userId && String(user.userId).toLowerCase().includes(lowercasedSearchText)) ||
      (user.emailAddress && user.emailAddress.toLowerCase().includes(lowercasedSearchText))
    );

    this.setState({users: filteredUsers});
  };

  fetchUsers = async () => {
    this.setState({loading: true});
    try {
      const {data: usersData} = await ApiService.getUsers();

      const uniqueUsersData = Array.from(new Map(usersData.map(item => [item.userId, item])).values());

      const users = uniqueUsersData.map((x) => ({
        ...x,
        key: x.userId,
      }));

      this.setState({users, allUsers: users, loading: false, searchText: ""});
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      message.error("Αποτυχία φόρτωσης χρηστών.");
      this.setState({loading: false});
    }
  };

  render() {
    const {
      users,
      loading,
      searchText,
    } = this.state;

    const columnsWithActions = [
      ...columns
    ];

    return (
      <div>
        <Heading>Χρήστες</Heading>
        <Wrapper>
          <Loading loading={loading}>
            <div style={{marginBottom: "10px"}}>
              <div style={{clear: "both"}}></div>
            </div>
            <div style={{paddingBottom: "20px"}}>
              <Search
                placeholder="Αναζητήστε στους χρήστες"
                allowClear
                value={searchText}
                onChange={this.onSearchTextChange}
                style={{maxWidth: 510, marginRight: "10px"}}
                disabled={loading}
              />
              <Button style={{float: "right", marginRight: "10px"}} type="round" onClick={() => this.fetchUsers()}
                      disabled={loading}>
                <ReloadOutlined/>
                Ανανέωση
              </Button>
            </div>
            <Table
              columns={columnsWithActions}
              dataSource={users}
              scroll={{x: "max-content"}}
              rowKey={(record) => record.userId}
              size="small"
              locale={{
                emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Δεν υπάρχουν δεδομένα"/>,
              }}
              pagination={{
                showSizeChanger: true,
                total: users ? users.length : 0,
              }}
            />
          </Loading>
        </Wrapper>
      </div>
    );
  }
}

export default withRouter(App);
